export default "__VITE_ASSET__74291bc9__"